import { businessDate } from './businessDate';

export const localDate = (date) => date == null ? businessDate() : `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
export const validPeriod = (from, to) => /^\d{4}-\d{2}-\d{2}$/.test(from || '') && /^\d{4}-\d{2}-\d{2}$/.test(to || '') && from <= to;
const number = value => Number(value || 0);
const sum = (rows, key = 'amount') => rows.reduce((total, row) => total + number(row[key]), 0);
export function dashboardData(snapshot) {
  const { sales = [], returns = [], purchases = [], lowStock = [], outOfStock = [], activeProducts = [] } = snapshot;
  const clients = new Map(), products = new Map(), days = new Map();
  const collect = (doc, sign) => {
    const day = days.get(doc.date) || { name: doc.date, amount: 0 };
    day.amount += sign * number(doc.amount); days.set(doc.date, day);
    const client = clients.get(doc.partyId) || { id: doc.partyId, name: doc.party, sales: 0, returns: 0, amount: 0 };
    client[sign > 0 ? 'sales' : 'returns'] += number(doc.amount);
    client.amount += sign * number(doc.amount); clients.set(doc.partyId, client);
    (doc.items || []).forEach(item => {
      const product = products.get(item.id) || { ...item, quantity: 0, amount: 0, amountHT: 0 };
      product.quantity += sign * number(item.quantity);
      product.amount += sign * number(item.amount);
      product.amountHT = product.amountHT == null || item.amountHT == null ? null : product.amountHT + sign * number(item.amountHT);
      products.set(item.id, product);
    });
  };
  sales.forEach(doc => collect(doc, 1)); returns.forEach(doc => collect(doc, -1));
  const gross = sum(sales), returned = sum(returns), net = gross - returned;
  const productRows = [...products.values()].sort((a, b) => b.quantity - a.quantity || b.amount - a.amount);
  const categories = new Map(), months = new Map();
  productRows.forEach(product => {
    const name = product.category || 'Sans catégorie';
    const category = categories.get(name) || { name, quantity: 0, amount: 0, amountHT: 0 };
    category.quantity += product.quantity; category.amount += product.amount;
    category.amountHT = category.amountHT == null || product.amountHT == null ? null : category.amountHT + product.amountHT;
    categories.set(name, category);
  });
  days.forEach(day => {
    const name = day.name.slice(0, 7), month = months.get(name) || { name, amount: 0 };
    month.amount += day.amount; months.set(name, month);
  });
  const margins = productRows.map(product => ({ ...product,
    cost: product.currentUnitCostHT == null ? null : number(product.currentUnitCostHT) * product.quantity,
    margin: product.currentUnitCostHT == null || product.amountHT == null ? null : product.amountHT - number(product.currentUnitCostHT) * product.quantity,
  }));
  const slowProducts = activeProducts.map(product => products.get(product.id) || product)
    .sort((a, b) => number(a.quantity) - number(b.quantity) || number(a.amount) - number(b.amount));
  return { sales, returns, purchases, lowStock, outOfStock, gross, returned, net,
    average: sales.length ? gross / sales.length : 0,
    purchased: sum(purchases), outstanding: sum(purchases, 'outstanding'),
    clients: [...clients.values()].sort((a, b) => b.amount - a.amount),
    products: productRows.filter(product => Number(product.quantity.toFixed(3)) !== 0), margins, slowProducts,
    categories: [...categories.values()].sort((a, b) => b.amount - a.amount),
    months: [...months.values()].sort((a, b) => a.name.localeCompare(b.name)),
    days: [...days.values()].sort((a, b) => a.name.localeCompare(b.name)) };
}
